import client from './client';

export const questions = () => client().get('/FAQ/GetAll');

export const contactSendApi = (data) => client().post('/Contact/Send', data);
